<div class="ai-assistant-container">

  <!-- AI Assistant Icon -->
  <button type="button"
    class="ai-assistant-icon"
    [class.panel-open]="isPanelVisible"
    [class.has-unread]="hasUnread"
    [attr.aria-label]="hasUnread ? 'AI assistant, unread messages' : 'AI assistant'"
    (click)="togglePanel()">
    <img
      src="assets/icons/eivira-brain-icon-black.svg"
      alt="Eivira AI assistant"
      class="assistant-icon-img"
      draggable="false">
  </button>

  <!-- Notification panel -->
  <div class="notification-panel" *ngIf="isPanelVisible" [@panelAnimation]>
    <div class="panel-header">
      <div class="panel-title-group">
        <span class="panel-title">AI Insights</span>
      </div>
      <button mat-icon-button class="panel-close-btn"
        (click)="closePanel()"
        matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="panel-body">
      <div class="panel-empty" *ngIf="messages.length === 0">
        No insights yet
      </div>

      <div class="notification-card"
        *ngFor="let notif of messages; trackBy: trackById"
        [@cardAnimation]>
        <div class="card-content" [innerHTML]="notif.message"></div>
      </div>
    </div>

    <div class="panel-footer">Powered by <strong>EIVIRA</strong></div>
  </div>

</div>
